var i={Opening:"Open",Closing:"Close",Liquidation:"Liquidate"},e={[i.Opening]:"green",[i.Closing]:"yellow",[i.Liquidation]:"red"};export{i as SectorBridgeAction,e as SectorBridgeActionColors};
//# sourceMappingURL=types.js.map